import DropDownListFactory from '@/Factories/ControlFactories/DropDownListFactory';
import ComponentManager from '@/Management/ComponentManager';

export default class CustomDropDownListFactory extends DropDownListFactory {

    public constructor(params: any) {
        super(params);
    }

}

ComponentManager.setFactory('CustomDropDownList', CustomDropDownListFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');